import { createSelector } from '@reduxjs/toolkit';
import { forEachRight } from 'lodash';
import moment from 'moment';
const reduxPostsReducer = (state) => state.reduxPosts;
export const postsLoadingSelector = createSelector(reduxPostsReducer, (reducer) => reducer.loading);
export const postsSelector = createSelector(reduxPostsReducer, (reducer) => reducer.data);
export const postsByThreadSelector = (threadId) => createSelector(postsSelector, (posts) => posts.filter((post) => post.thread === threadId));
export const sortedPostsByThreadSelector = (threadId) => createSelector(postsByThreadSelector(threadId), (posts) => {
    const sortedPosts = posts.sort((a, b) => moment(a.postedOn).diff(b.postedOn));
    return sortedPosts;
});
export const sortedPostsByDateAndThreadSelector = (thread, threadId) => createSelector(sortedPostsByThreadSelector(threadId), (sortedPosts) => {
    if (thread && thread.unreadPostCount > 0) {
        let newPosts = thread.unreadPostCount;
        forEachRight(sortedPosts, (post, index) => {
            if (newPosts === 0) {
                sortedPosts[index] = Object.assign(Object.assign({}, sortedPosts[index]), { nextIsNew: true });
                newPosts -= 1;
            }
            if (newPosts > 0)
                newPosts -= 1;
        });
    }
    const postsByUsers = {};
    let group = [];
    let user;
    let date;
    let lastDate = 0;
    sortedPosts.forEach((post, index) => {
        if (!date) {
            date = post.postedOn;
            postsByUsers[date] = {};
        }
        else if (date && moment(post.postedOn).diff(moment(date)) > 3600000) {
            if (group.length > 0) {
                postsByUsers[date][lastDate] = group;
            }
            group = [];
            date = post.postedOn;
            postsByUsers[date] = {};
            lastDate = index;
        }
        if (post.authorInst && post.authorInst.name !== user) {
            if (group.length > 0)
                postsByUsers[date][lastDate] = group;
            user = post.authorInst.name;
            group = [];
            lastDate = index;
        }
        group.push(post);
    });
    if (group.length > 0 && date)
        postsByUsers[date][lastDate] = group;
    return postsByUsers;
});
